$('document').ready(function () {

    $('#FederationID').on('change', function (event) {
        event.preventDefault();

        const url = $('#GetAssociationsUrl').val();
        const federationId = parseInt($('#FederationID').val());

        if (federationId > 0) {

            const data = { ForbundID: federationId };

            $.ajax({
                url: url,
                method: 'post',
                contentType: 'application/json',
                data: JSON.stringify(data),
                headers: {
                    RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val()
                },
                success: function success(data) {

                    $('#AssociationID').empty();
                    $('#AssociationID').append($('<option>', {
                        value: '0',
                        text: 'Välj förening'
                    }));
                    data.map(function (association) {
                        $('#AssociationID').append($('<option value="' + association.ForeningID + '">' + association.Namn + '</option>'));
                    });
                    $('#AssociationID').prop('disabled', false);
                }
            });
        };
    });

    $('#AssociationID').on('change', function (event) {

        const associationId = parseInt($('#AssociationID').val());

        if (associationId > 0) {
            $('input').prop('disabled', false);
            $('button[type="submit"]').prop('disabled', false);
        } else {
            $('input').val('');
            $('input').prop('disabled', true);
            $('button[type="submit"]').prop('disabled', true);
        }
    });

    $('form').on('submit', function (event) {

        const validFirstName = $('#FirstName').val().length > 0;
        const validLastName = $('#LastName').val().length > 0;
        var email = $('#Email').val();
        //const mailRegEx = /(^[a-zA-Z0–9._%+\-åäöÅÄÖ]+@[a-zA-Z0–9.\-_åäöÅÄÖ]+\.[a-zA-Z]{2,}$)/;
        const mailRegEx = /^[a-zA-Z0-9._%+\-åäöÅÄÖ]+@[a-zA-Z0-9._\-åäöÅÄÖ]+\.[a-zA-Z]{2,}$/;
        const personalIdentityNo = /^(19|20)?[0-9]{6}[-]?[0-9]{4}$/;

        const validEmail = mailRegEx.test(email);
        const validPersonalIdentityNo = personalIdentityNo.test($('#PersonalIdentityNo').val())

        if (validFirstName) {
            $('#FirstName').removeClass('is-invalid');
        } else {
            $('#FirstName').addClass('is-invalid');
        }

        if (validLastName) {
            $('#LastName').removeClass('is-invalid');
        } else {
            $('#LastName').addClass('is-invalid');
        }

        if (validEmail) {
            $('#Email').removeClass('is-invalid');
        } else {
            $('#Email').addClass('is-invalid');
        }

        if (validPersonalIdentityNo) {
            $('#PersonalIdentityNo').removeClass('is-invalid');
        } else {
            $('#PersonalIdentityNo').addClass('is-invalid');
        }

        if (validFirstName && validLastName && validEmail && validPersonalIdentityNo) {
            $('#spinner').modal({ backdrop: 'static', keyboard: false, show: true })
        }

        return validFirstName && validLastName && validEmail && validPersonalIdentityNo;
    });
});